import { Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { LabelsDataService } from '@services/labels-data.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { CityFormControl } from './city-form-control';

@Component({
  standalone: false,
  selector: 'app-city-form-control',
  templateUrl: './city-form-control.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CityFormControlComponent),
      multi: true
    }
  ]
})
export class CityFormControlComponent
  extends AbstractFormControlComponent<CityFormControl>
  implements OnInit, OnChanges, ControlValueAccessor
{
  @Input() override parentForm: FormGroup = new FormGroup({});
  @Input() override formControlName: string = undefined;
  @Input() override title: string = undefined;
  @Input() autocompleteOptions: any[] = [];

  onChange: any = (value: string) => {};
  onTouched: any = () => {};
  requiredText: string = '';
  faCheck: any = faCheck;

  filteredOptions: Observable<any[]>;

  constructor(public labelsDataService: LabelsDataService) {
    super();
  }

  ngOnInit(): void {
    this.requiredText = this.labelsDataService.getData('COMMON.PleaseFillInThisFieldText');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.autocompleteOptions) {
      this.initFilteredOptions();
    }
  }

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}

  itemSelected(event: any): void {
    this.parentForm.get(this.formControlName).patchValue((event.option.value + '').allToUpperCase());
  }

  public get maxLength(): number {
    return this.control.maxLength;
  }

  public get readOnlyCss(): boolean {
    return this.control.readOnlyCss || false;
  }

  public get autocompleteLabelField(): string {
    return this.control.autocompleteLabelField;
  }

  public get hideSuccessMark(): boolean {
    return this.control.hideSuccessMark || false;
  }

  public get hideErrorMessages(): boolean {
    return this.control.hideErrorMessages || false;
  }

  private initFilteredOptions(): void {
    const control = this.parentForm.get(this.formControlName);

    if (!control) {
      return;
    }

    this.filteredOptions = control.valueChanges.pipe(
      startWith(control.value),
      map((value: string) => this.filterOptions(value))
    );
  }

  private filterOptions(value: string): any[] {
    const filterValue = (value ?? '').toLowerCase();

    return (
      this.autocompleteOptions?.filter(item =>
        item[this.autocompleteLabelField]?.toLowerCase().includes(filterValue)
      ) ?? []
    );
  }
}
